export default __webpack_public_path__ + "static/media/city.54987afd.png";